import { cn } from '@/lib/utils';
import { ColumnLabel } from '@/components/ui/Title.tsx';
import { billGridClass } from './billGrid';

interface SectionColumnHeaderProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Treść obok „Pozycja" — tam trafia przełącznik „Tylko zmienione". */
  children?: React.ReactNode;
}

/** Pasek nagłówków kolumn nad listą sekcji — trzyma tę samą siatkę co wiersze. */
const SectionColumnHeader = ({
  children,
  className,
  ...props
}: SectionColumnHeaderProps) => (
  // `@container` własny, bo próg siatki mierzy szerokość paska, nie okna.
  <div className="@container">
    <div
      className={cn(
        billGridClass,
        'items-center px-[19px] pb-2.5 pt-4',
        className,
      )}
      {...props}
    >
      <div className="@max-[640px]:col-span-1 col-span-2 flex flex-wrap items-center gap-3.5">
        <ColumnLabel>Pozycja</ColumnLabel>
        {children}
      </div>
      <ColumnLabel className="text-right">Kwota</ColumnLabel>
      <span className="@max-[640px]:hidden" />
    </div>
  </div>
);

export default SectionColumnHeader;
